import {
    SET_EULA,
    FETCHING_EULA,
} from './constants'

export function setEula(eula, hash) {
    return { type: SET_EULA, payload: { eula, hash } }
}

export function fetchingEula() {
    return { type: FETCHING_EULA }
}



// WEBPACK FOOTER //
// ./src/features/Eula/data/eula/actions.js